import Lead from '@/store/Models/Lead'
import NeedsAnalysisLead from '@/store/Models/NeedsAnalysisLead.js'
import { ConvertFields, ConvertAssetFields, RealEstateCurrencyFields, InsuranceCurrencyFields, IncomeCurrencyFields } from '@/components/utils/FormatNeedsAnalysisFields.js'


export default {
    getLeads(agent_code, filters, options) {
        Lead.commit((state) => {
            state.loading = true
        })
        var params = {
            ...options,
            ...filters
        }
        this.cancelQRequest("getLeadsQ");
        return this.getRequest('/api/private/leads/agent/' + agent_code, params, "getLeadsQ").then(function(json) {
            if (typeof json.meta == 'undefined') {
                return json;
            }
            Lead.commit((state) => {
                state.loading = false
                state.total = json.meta.total
                if (json.meta.filters) {
                    state.availableFilters = json.meta.filters
                }
            })
            return json;
        })
    },

    getStatusOptions() {
        this.cancelQRequest("LeadStatusOptions");
        return this.getRequest('/api/private/leads/statuses', null, "LeadStatusOptions").then(function(json) {
            return json.data;
        })
    },

    getLeadCounts(agent_code) {
        this.cancelQRequest("LeadCountQ");
        return this.getRequest('/api/private/leads/agent/' + agent_code + "/counts", null, "LeadCountQ").then(function(json) {
            return json.data;
        })
    },

    getLead(lead_code, agentcode, attributes) {
        this.cancelQRequest("getLeadQ");
        Lead.commit((state) => {
            state.currentLead = null
        })
        var params = {};
        if (attributes) {
            var params = {
                attr: attributes.join(",")
            }
        }
        return this.getRequest('/api/private/leads/agent/' + agentcode + "/leads/" + lead_code, params, "getLeadQ").then(function(json) {
            //OptLead.insert({ data: json.data })
            return json.data;
        })
    },

    updateLead(agent_code, lead) {
        var params = {};

        return this.putRequest('/api/private/leads/agent/' + agent_code + '/leads/' + lead.LeadCode, { lead: lead }).then(function(json) {
            //OptLead.insert({ data: json.data })
            return json
        })
    },

    createReferral(agent_code,lead) {
        this.cancelQRequest("createReferral");
        return this.postRequest('/api/private/leads/agent/' + agent_code + '/leads', lead)
        .then(function(json){
            return json
        })
        .catch(function(err) {
            return err
        })
    },

    pushLeadToCESCSwitchboard(lead_assignment_id){
        var params = {};

        return this.postRequest('/api/private/lead_assignment/cesc_push_to_switchboard', { LeadAssignmentID: lead_assignment_id }).then(function(json) {
            //OptLead.insert({ data: json.data })
            return json
        })
    }
}
